import React, { memo } from 'react';
import styled from 'styled-components';
import type { RecentProcessItem } from '../types/types';

type RecentProcessListProps = {
	items: RecentProcessItem[];
	showTime?: boolean; // 시각 표시 여부
};

// 최근 처리 이력 (칩 목록)
const RecentProcessList = memo<RecentProcessListProps>(({ items, showTime = false }) => {
	if (items.length === 0) return null;

	return (
		<Wrapper>
			<Label>최근 처리</Label>
			<ChipList>
				{items.map((item, index) => (
					<Chip key={`${item.bibNumber}-${index}`}>
						{showTime && <Time>{item.processedAt}</Time>}
						{item.bibNumber} {item.name}
					</Chip>
				))}
			</ChipList>
		</Wrapper>
	);
});

RecentProcessList.displayName = 'RecentProcessList';

export default RecentProcessList;

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	margin-top: 60px;
	overflow: hidden;
`;
const Label = styled.div`
	font-size: 14px;
	flex-shrink: 0;
	color: ${({ theme }) => theme.colors.deepGrayFontColor};
`;
const ChipList = styled.div`
	display: flex;
	gap: 12px;
	overflow: hidden;
`;
const Chip = styled.div`
	font-size: 14px;
	white-space: nowrap;
	padding: 10px 16px;
	border-radius: 20px;
	color: ${({ theme }) => theme.colors.blackColor};
	background-color: ${({ theme }) => theme.colors.lightGrayHoverColor};
`;
const Time = styled.span`
	color: ${({ theme }) => theme.colors.lightGrayFontColor};
	margin-right: 6px;
`;
